module.exports = __webpack_public_path__ + "img/img-14.97e05d62.png";